const { MALAYSIA, SINGAPORE } = require('../constants/countries-map')

const DEALER_ROLE = 'dealer'
const HTA_DEALER_ROLE = 'hta dealer'
const HTS_DEALER_ROLE = 'hts dealer'
const CS_ROLE = 'cs'
const SALES_ROLE = 'sales'

const ROLES_MAP = {
  [MALAYSIA]: [DEALER_ROLE, HTA_DEALER_ROLE, HTS_DEALER_ROLE, SALES_ROLE, CS_ROLE],
  [SINGAPORE]: [DEALER_ROLE, SALES_ROLE, CS_ROLE],
}

module.exports = { DEALER_ROLE, HTS_DEALER_ROLE, HTA_DEALER_ROLE, CS_ROLE, SALES_ROLE, ROLES_MAP }
